// extracted by mini-css-extract-plugin
export var alternate = "_1p-j";
export var black = "_1p-6";
export var blue = "_1p-f";
export var blueLight = "_1p-e";
export var brand = "_1p-8";
export var darkMode = "_1p-b";
export var error = "_1p-a";
export var gray = "_1p-5";
export var grayBlue = "_1p-d";
export var iconWrapper = "_1p-3";
export var inactive = "_1p-7";
export var indigo = "_1p-g";
export var orange = "_1p-i";
export var pink = "_1p-h";
export var primary = "_1p-0";
export var purple = "_1p-9";
export var success = "_1p-4";
export var warning = "_1p-c";
export var white = "_1p-1";
export var whiteSuccess = "_1p-2";